import { Button } from 'primereact/button';
import './App.css';
import PageMarketingV2Menu from './PageMarketingV2Menu';
import './Pricing.css';
import V2HomeCard from './V2HomeCard';
import PricingCard from './PricingCard';
import PricingItem from './PricingItem';

function Pricing() {
    return (
        <div>
            <PageMarketingV2Menu />
            Pricing
            <div style={{ marginTop: '4em' }}>
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        width: '100%',
                    }}
                >
                    <PricingCard
                        title='Free'
                        price='0.0'
                    >
                        <PricingItem title='Online platform' />
                        <PricingItem title='Your devices' />
                        <PricingItem title='Your campaigns' />
                        <PricingItem title='24/7 Support' />
                    </PricingCard>
                    <PricingCard
                        title='Starter'
                        price='4.9'
                    >
                        <div>
                            <PricingItem title='Online platform' />
                            <PricingItem title='Marketplace' />
                            <PricingItem title='Unlimited Campaigns' />
                            <PricingItem title='Devices Campaigns' />
                            <PricingItem title='24/7 Support' />
                        </div>
                    </PricingCard>
                    <PricingCard
                        title='Standard'
                        price='9.9'
                    >
                        <div>
                            <PricingItem title='Online platform' />
                            <PricingItem title='Marketplace' />
                            <PricingItem title='Unlimited Campaigns' />
                            <PricingItem title='Unlimited Campaigns' />
                            <PricingItem title='24/7 Support' />
                            <PricingItem title='Channels' />
                            <PricingItem title='Broadcasting' />
                        </div>
                    </PricingCard>
                    <PricingCard
                        title='Enterprise'
                        price={null}
                    >
                        <div>
                            <PricingItem title='Custom features' />
                            <PricingItem title='Personalized assistance' />
                        </div>
                    </PricingCard>
                </div>
            </div>
        </div>
    );
}

export default Pricing;